var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order"},[_c('List',{attrs:{"page":_vm.page},on:{"requestList":_vm.handleLoad}},[_c('OrderCell',{attrs:{"orderList":_vm.orderList,"cellList":_vm.cellList},scopedSlots:_vm._u([{key:"region",fn:function(ref){
var item = ref.item;
return [(item.customerOrg)?_vm._l((item.customerOrg),function(org){return _c('p',{key:org.id},[_vm._v(_vm._s(org.orgName))])}):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }